
import Vue from "vue";

export default Vue.extend({
	props: {
		progress: {
			type: Number,
			required: true
		},
	},
	computed: {
		progressValue():number{
			return this.progress * 100;
		}
	},
	mounted(){
		let splashEl = document.getElementById("splash");
		if (!splashEl) return;
		splashEl.remove();
	}
});
